import {
  UseMutationOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query"
import { PaginationState } from "@tanstack/react-table"
import type { Prisma } from "@tfg/db"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useRefreshTokenCount = (
  filterOption: string | null,
  searchValue?: string
) =>
  useQuery(["refreshTokenCount", filterOption, searchValue], async () => {
    const res = await httpClient.get<number>("/admin/refresh-token/count", {
      params: { filterOption, searchValue },
    })
    return res.data
  })

export const useRefreshTokenLogsQuery = (
  fetchDataOptions: PaginationState,
  prismaSorting: Prisma.RefreshTokenOrderByWithRelationInput[] | [],
  filterOption: string | null,
  searchValue?: string
) =>
  useQuery(
    [
      "refreshTokenLogs",
      fetchDataOptions,
      prismaSorting,
      filterOption,
      searchValue,
    ],
    async () => {
      const res = await httpClient.get<AdminResponses.RefreshTokenLogs[]>(
        "/admin/refresh-token",
        {
          params: {
            fetchDataOptions,
            prismaSorting,
            filterOption,
            searchValue,
          },
        }
      )
      return res.data
    },
    { keepPreviousData: true }
  )

export const useDeleteRefreshTokenMutation = (
  options?: UseMutationOptions<void, unknown, number>
) => {
  return useMutation({
    ...options,
    mutationFn: async (refreskTokenId) => {
      return httpClient.delete(`/admin/refresh-token/${refreskTokenId}`)
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries(["refreshTokenLogs"])
    },
  })
}
